import { PaginationControls } from "@/components/dashboard/pagination-controls"
import { Skeleton } from "@/components/ui/skeleton"
import { cn } from "@/lib/utils"

interface DataTablePaginationProps {
  page: number
  totalPages: number
  totalItems: number
  itemsPerPage: number
  onPageChange: (page: number) => void
  onLimitChange: (limit: number) => void
  entityName?: string
  isLoading?: boolean
  className?: string
  showLimits?: boolean
  limits?: number[]
  children?: React.ReactNode
}

export function DataTablePagination({
  page,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
  onLimitChange,
  entityName = "items",
  isLoading = false,
  className,
  showLimits = true,
  limits,
  children,
}: DataTablePaginationProps) {
  // Logic to calculate showing range
  const start = totalItems === 0 ? 0 : (page - 1) * itemsPerPage + 1
  const end = Math.min(page * itemsPerPage, totalItems)

  if (totalItems === 0 && !isLoading) return null

  return (
    <div className={cn(
      "border-t py-2 px-4 flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0 bg-card rounded-b-md transition-all",
      className
    )}>
      <div className="text-xs text-muted-foreground">
        {isLoading ? (
          <Skeleton className="h-4 w-24" />
        ) : (
          <>
            Showing <span className="font-medium text-foreground">{start}</span>-
            <span className="font-medium text-foreground">{end}</span> of{" "}
            <span className="font-medium text-foreground">{totalItems}</span> {entityName}
          </>
        )}
      </div>
      <div className="flex items-center gap-4">
        {children}
        <PaginationControls
          currentPage={page}
          totalPages={totalPages}
          totalItems={totalItems}
          itemsPerPage={showLimits ? itemsPerPage : 0}
          onPageChange={onPageChange}
          onLimitChange={onLimitChange}
          limits={limits}
        />
      </div>
    </div>
  )
}
